import React, { useEffect, useState } from "react";
import Meta from "../../components/Meta";
import Link from "next/link";
import { useRouter } from 'next/router';
import Post from "../../components/case-studies/post";
import Faq from "../../components/faq/faq";
import Testimonial2 from "../../components/testimonial/Testimonial2";
import Calltoaction from "../../components/calltoaction";
import Blog from "../blog";

const Irbin = () => {
  useEffect(() => {
    const header = document.querySelector("header");
    header.classList.add("bg-white/[.05]");
  }, []);

  const [videoModal, setvideoModal] = useState(false);
  const [url, setUrl] = useState(null);
  const router = useRouter();

  return (
    <>
      <Meta title="IRBin | CIRSYS Tech - Desarrollamos tecnología para el beneficio social." desc={"En CIRSYS buscamos crear tecnología para un mundo más sostenible. Somos una empresa que aporta valor a los negocios desarrollando proyectos con Inteligencia Artificial, Robotica Social, Automatización, desarrollo de Hardware y Software."} keyword={"Inteligencia Artificial, Robotica Social, Automatización, desarrollo de Hardware y Software, proyectos, irbin, cirsys, cirsys tech, tecnología, medio ambiente"} />
      <Post />
      <Faq />
      {/* <Testimonial2/> */}
      <Calltoaction />
      <Blog />
    </>
  );
};

export default Irbin;